module.exports = __webpack_public_path__ + "static/media/iphone 12 banner2.7973967c.jpg";